module.exports = __webpack_public_path__ + "assets/img/img100.8f939b8e.png";